import RequestAQuoteLayoutD from 'components/layout-a/forms/RequestAQuoteLayoutD';
import { CommonContext } from '../../pages/_app';
import { createContext, Fragment, useContext, useEffect, useRef, useState } from 'react';
import MasterClassContainer from './container';
import SessionPopup from './SessionsPopup';
import Image from 'next/image';
import ReactPlayer from 'react-player';
import playIcon from '../../public/website_next_images/masterclass/videoThumbnailImg.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperCore } from 'swiper/types';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination } from 'swiper';
import FaqBlock from './FAQ';
import BookYourSeatButton from './bookYourSeatButton';
import { UserLocation } from '../../interfaces/city';
import { getUserLocationData } from '../../lib/common/userLocation';
import moment from 'moment';
import 'moment-timezone';
import Timer from 'components/common/Timer';
import SuccessPopup from './SuccessPopup';
import { tracker } from '../../lib/events/tracker';
import BannerRibbon from './BannerRibbon';
import Reviews from './Reviews';
import { EventData } from '../../lib/events/constants';
import FormatDate, { toMonthName } from '../../lib/common/formatDate';
import dynamic from 'next/dynamic';
import { handleDataTracker } from './tracker';
import BookYourSeatButtonV2 from './BookYourSeatButtonV2';
import StickyBookYourSeatButton from './StickyButton/stickyBookYourSeatButton';
import UGBookYourSeatForm from './UpGrad/BookYourSeat';
import UpGradFooter from './UpGrad/Footer';
import UgBookYourSeatPopUpV2 from './UpGrad/BookYourSeatV2';
import UpgradSessionPopup from './UpGrad/SessionsPopup';

const BookYourSeatPopUpV2 = dynamic(() => import('./BookYourSeatV2'), { ssr: false });
const BookYourSeatForm = dynamic(() => import('./BookYourSeat/index'), { ssr: false });

const MasterClassLayout: React.FC<any> = ({ page, sections, userLocation, countDownTimerInSeconds }) => {
  const [show, setShow] = useState(false);
  const [userCurrentLocation, setUserCurrentLocation] = useState(userLocation);
  const [currentCourse, setCurrentCourse] = useState(0);
  const [sessionEndTime, setSessionEndTime] = useState(countDownTimerInSeconds);
  const [isSessionText, setSessionText] = useState(true);

  const [showSessionPopUp, setShowSessionPopUp] = useState(false);
  const [showBookYouSeatPopUp, setShowBookYouSeatPopUp] = useState(false);
  const [showBannerVideo, setShowBannerVideo] = useState(false);
  const swiperRef = useRef<SwiperCore>();
  const [currentSlide, setCurrentSlide] = useState<number>(1);

  //top header sticky
  const [isVisible, setIsVisible] = useState(false);
  // bottom  button sticky
  const [isButtonSticky, setButtonSticky] = useState(false);

  const [formClickedSection, setFormClickedSection] = useState('');

  useEffect(() => {
    checkShowTimer();

    window.addEventListener('scroll', listenToScroll);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', listenToScroll);
      window.addEventListener('scroll', handleScroll);
    };
  }, []);

  const listenToScroll = () => {
    let heightToVisibleFrom = 300;
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    if (winScroll > heightToVisibleFrom) {
      setIsVisible(true);
      window.removeEventListener('scroll', listenToScroll);
    } else {
      setIsVisible(false);
    }
  };

  const handleScroll = () => {
    const position = window.pageYOffset;
    if (position > 300) {
      setButtonSticky(true);
      window.removeEventListener('scroll', handleScroll);
    } else {
      setButtonSticky(false);
    }
  };

  const bannerInfo = sections.filter((section) => section.section == 'banner')[0];

  const bannerData = bannerInfo && JSON.parse(bannerInfo?.data);

  const timer = page?.timer;

  const sessionTime = page?.timer;

  const webinarEndDate = page?.endTimer;

  // const sessionDate = moment.tz(sessionTime, 'asia/calcutta').toDate();
  // const sessionFormatedDate = moment(sessionDate).format('YYYY/M/D HH:mm:ss');

  // getLocationData
  const checkShowTimer = async () => {
    // const userLocation: UserLocation = await getUserLocationData();
    // const timezone = userLocation.city.timezone_name;
    // const currentSessionTime = moment.tz(sessionTime, timezone);
    // const sessionEndTimeInSec = currentSessionTime.toDate().getTime();

    if (sessionEndTime < Date.now()) {
      setSessionText(false);
    }
    // setSessionEndTime(sessionEndTimeInSec);
  };
  const logo = 'https://d2o2utebsixu4k.cloudfront.net/KH-New-logo/kh-desktop-new-logo.svg';

  const logoName = page?.tenant?.slug == 'upgrad' ? 'UpGrad Logo' : 'Knowledgehut Logo';

  return (
    <MasterClassContainer>
      <CommonContext.Provider value={[userCurrentLocation, setUserCurrentLocation, currentCourse, setCurrentCourse]}>
        <div className="masterclass-font relative">
          <header className="header sticky top-0 z-[200] md:bg-[#FBF8F8] bg-white px-4 md:px-0 md:shadow-header items-center md:h-[68px] flex h-14">
            <div className="max-w-[1200px] md:mx-auto md:px-[15px] w-full h-full">
              <div className="flex justify-between items-center h-full">
                <div className="boxShadow-[header] h-full flex items-center md:m-0 ml-[6px]">
                  <div
                    className={`w-auto ${
                      page?.tenant?.slug === 'upgrad' ? 'md:w-[252px] md:h-[47px]' : 'md:w-[138px] md:h-[44px]'
                    }  md:block hidden`}
                  >
                    <img src={logo} alt={logoName} height="44" width="auto"/>
                  </div>
                  <div className="w-auto md:w-[138px] md:hidden block">
                    <img
                      src={logo}
                      alt={logoName}
                      width="100%"
                      height="31"
                      className={`${'h-[31px]'}`}
                    />
                  </div>
                </div>
                <div className="md:flex hidden justify-end lg:flex-grow items-center">
                  {isSessionText && bannerData?.showTimerInNav && bannerData?.timerText && (
                    <div className="offer-countdown flex items-center mr-8">
                      {isVisible && (
                        <>
                          <p className="text-base leading-[19px] text-black whitespace-nowrap mr-6">
                            {bannerData.timerText}
                          </p>
                          <div className="flex  md:w-[211px]">
                            {bannerData.showTimerInNav && <Timer deadline={sessionEndTime} isHeaderTimer={true} />}
                          </div>
                        </>
                      )}
                    </div>
                  )}
                  {bannerData?.ctaTargetLink && bannerData?.showCtaInNav && (
                    <a
                      className="target-link-ele btn-primary bg-[#DB4144] text-white"
                      href={bannerData?.ctaTargetLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-tracker-id={`mc-click-register-rhs-top-sticky-nav`}
                    >
                      {bannerData.ctaText} <i className="bg-spriteImg button-header-arrow" />
                    </a>
                  )}
                  {!bannerData?.ctaTargetLink && bannerData?.showCtaInNav && (
                    <button
                      className="btn-primary bg-[#DB4144] text-white"
                      onClick={() => {
                        setShowBookYouSeatPopUp(true);
                        handleDataTracker('mc-click-register-rhs-top-sticky-nav', '', page.name);
                        setFormClickedSection('mc-click-register-rhs-top-sticky-nav');
                      }}
                    >
                      {bannerData.ctaText} <i className="bg-spriteImg button-header-arrow" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </header>
          {sections?.map((section, id) => {
            let data = JSON.parse(section.data);
            return (
              <>
                {section.schemaId.code == 'mc-banner-1' && (
                  <>
                    <section className="md:bg-[#FBF8F8] bg-white px-[16px] md:px-0 md:pt-10 md:pb-[75px]" key={id}>
                      <div className=" px-0 md:mx-auto container md:px-[15px]">
                        <div className="flex flex-wrap justify-center md:place-items-center mt-4">
                          {data?.heading && (
                            <h1 className="text-2xl leading-9 font-bold md:text-[64px] text-center md:mb-6 mb-[17px] md:leading-[83px] max-w-[1085px] px-0">
                              <span
                                className="h1-heading mr-[10px]"
                                dangerouslySetInnerHTML={{ __html: `${data.heading}` }}
                              ></span>
                              <span
                                className="h1-subheading font-regular"
                                dangerouslySetInnerHTML={{ __html: `${data.subHeading}` }}
                              ></span>
                            </h1>
                          )}
                          {data?.shortDescription && (
                            <p className="text-center font-medium xs:text-xs leading-[18px] md:text-lg md:leading-[27px]  xs:text-[#666] max-w-[609px] w-auto mb-[35px] md:mb-0">
                              {data.shortDescription}
                            </p>
                          )}
                        </div>
                      </div>
                    </section>

                    <section className="md:bg-[#FBF8F8] bg-[#F8FAFE] px-4 md:px-0 md:pb-16 pb-8">
                      <div className=" px-0 md:mx-auto md:max-w-[1200px] md:px-[15px]">
                        <div className="flex flex-wrap justify-center md:place-items-center md:mt-0 mt-6">
                          {(data?.videoThumbnailImage || data?.video) && (
                            <div className=" md:place-items-center mx-auto md:mt-0 -mt-6">
                              <div className="relative !w-full md:!w-[968px] md:!h-[530px] !h-auto rounded-2xl overflow-hidden ">
                                <div
                                  className={` ${showBannerVideo ? ' hidden' : 'block'} ${
                                    data?.video ? 'absolute' : 'relative'
                                  } z-40 w-full h-full `}
                                >
                                  <div className="relative  h-full">
                                    <div className="master-next-image md:!w-[968px] md:!h-[530px] !w-full !h-auto">
                                      <img
                                        src={`${process.env.NEXT_PUBLIC_AWS_URI}/${data.videoThumbnailImage}`}
                                        alt="Video-Thumbnail-Image"
                                        className="!block md:!w-[968px] md:!h-[530px] !w-full !h-auto"
                                        width="968"
                                        height="530"
                                      />
                                    </div>

                                    <div className="absolute z-[49] top-0 left-0 right-0 bottom-0 bg-black bg-opacity-[0.15]"></div>
                                    {data?.video && (
                                      <div
                                        className={` ${
                                          showBannerVideo ? ' hidden ' : 'block '
                                        } z-50 w-14 h-14 md:w-20 md:h-20 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2`}
                                      >
                                        <img
                                          onClick={() => {
                                            setShowBannerVideo(true);
                                          }}
                                          src="https://d2o2utebsixu4k.cloudfront.net/master-class/playicon.png"
                                          alt="play-icon-Image"
                                          className="!block !w-full !h-auto"
                                          width="80"
                                          height="80"
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                                {data?.video && (
                                  <ReactPlayer
                                    className="review-react-player !w-full !h-full md:!w-[968px] md:!h-[530px]"
                                    url={`${process.env.NEXT_PUBLIC_AWS_URI}/${data.video}`}
                                    playing={showBannerVideo}
                                    controls

                                    // onReady={}
                                  />
                                )}
                              </div>
                            </div>
                          )}
                          <div className="border-0 md:border md:border-[#DB4144] md:border-opacity-20 flex items-center md:px-2 md:py-[7px] p-0 rounded-lg md:mt-14 xs:w-full md:w-auto md:max-w-[929px]">
                            <div className=" items-center md:flex block xs:w-full">
                              {isSessionText && data.timerText && data.showTimer && (
                                <div className="offer-countdown md:items-center md:pl-8 md:mr-12">
                                  <p className="mt-8 mb-6 md:mb-3 md:mt-0 xs:block md:text-xl max-w-full md:max-w-[268px] overflow-hidden text-sm text-black font-medium md:leading-6 leading-4 text-center">
                                    {data.timerText}
                                  </p>
                                  <div className="flex justify-center md:w-[287px]">
                                    {data.showTimer && <Timer deadline={sessionEndTime} isHeaderTimer={false} />}
                                  </div>
                                </div>
                              )}
                              {isButtonSticky && (
                                <StickyBookYourSeatButton
                                  data={data}
                                  setShowBookYouSeatPopUp={setShowBookYouSeatPopUp}
                                  sectionName={`mc-click-register-${section.schemaId.code}-sticky`}
                                  setFormClickedSection={setFormClickedSection}
                                  ctaPriceText={page?.ctaPriceText || ''}
                                  programName={page.name}
                                />
                              )}
                              <BookYourSeatButton
                                data={data}
                                setShowBookYouSeatPopUp={setShowBookYouSeatPopUp}
                                sectionName={`mc-click-register-${section.schemaId.code}`}
                                setFormClickedSection={setFormClickedSection}
                                ctaPriceText={page?.ctaPriceText || ''}
                                customStyles="mt-[30px] md:mt-0"
                                programName={page.name}
                              />
                            </div>
                          </div>
                          {data?.bookSessionText && data?.bookSessionLinkText && (
                            <div className="md:mt-12 mt-6 flex w-full justify-center">
                              <p className="md:text-xl md:leading-6 text-sm leading-4">
                                {data?.bookSessionText}
                                <button
                                  onClick={() => {
                                    setShowSessionPopUp(!showSessionPopUp);
                                    handleDataTracker('mc-click-register-book-session', '', page.name);
                                    setFormClickedSection('mc-click-register-book-session');
                                  }}
                                  className="text-[#DB4144] xs:underline cursor-pointer ml-1"
                                  data-bs-target="#staticBackdrop"
                                  data-bs-toggle="modal"
                                >
                                  {data?.bookSessionLinkText}
                                </button>
                              </p>
                            </div>
                          )}

                          {data?.tags?.length > 0 && (
                            <div className="md:justify-center flex flex-wrap border border-[#E78350] border-opacity-30  w-full md:bg-[#FBF8F8] bg-white md:mb-0 rounded md:shadow-none shadow-[0px_3px_1px_rgb(255_123_81_/_20%)] md:border-none md:mt-16 mt-8">
                              <ul className="bootcamp_list-wrap md:flex items-center flex-wrap justify-center md:gap-x-[26px] md:gap-y-6 md:px-0 px-4 md:w-auto w-full">
                                {data.tags.map((tag: any, id: number) => {
                                  return (
                                    <>
                                      <li
                                        className="bootcamp_list xs:shadow-none md:rounded rounded-none mb-0 flex items-center py-[7px] md:px-4 px-0 md:border md:border-[#E78350] md:border-opacity-30 xs:border-b xs:border-[#F4F8FF] md:shadow-[0px_3px_1px_rgb(255_123_81_/_20%)]"
                                        key={id}
                                      >
                                        <div className="flex items-center justify-center relative icon-box md:flex h-6 w-6">
                                          <span className={`bg-spriteImg ${tag.icon} flex items-center`} />
                                        </div>
                                        <div className="content-box ml-[10px]">
                                          <p className="text-sm leading-6 font-regular text-black">{tag.label}</p>
                                        </div>
                                      </li>
                                    </>
                                  );
                                })}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </section>
                  </>
                )}
                {section.schemaId.code == 'mc-banner-2' && (
                  <>
                    <section className="md:bg-[#FBF8F8] bg-white px-4 md:px-0 md:py-12 pt-4 pb-8">
                      {isButtonSticky && (
                        <StickyBookYourSeatButton
                          data={data}
                          setShowBookYouSeatPopUp={setShowBookYouSeatPopUp}
                          sectionName={`mc-click-register-${section.schemaId.code}-sticky`}
                          setFormClickedSection={setFormClickedSection}
                          ctaPriceText={page?.ctaPriceText || ''}
                          programName={page.name}
                        />
                      )}

                      <div className=" px-0 md:mx-auto md:max-w-[1200px] md:px-[15px]">
                        <div className="flex flex-wrap items-center">
                          <div className="grid grid-cols-1 md:grid-cols-12 ">
                            <div className="md:col-span-6">
                              <div className="flex flex-wrap">
                                {data.heading && (
                                  <h1 className="text-2xl md:text-left text-center leading-9 font-bold md:text-[36px] md:leading-[47px] md:mb-8 mb-[17px]">
                                    <span
                                      className="h1-heading-b2 mr-[10px]"
                                      dangerouslySetInnerHTML={{ __html: `${data.heading}` }}
                                    ></span>
                                    <span
                                      className="h1-subheading-b2 font-regular"
                                      dangerouslySetInnerHTML={{ __html: `${data.subHeading}` }}
                                    ></span>
                                  </h1>
                                )}
                                {data?.shortDescription && (
                                  <p className="text-xs md:text-lg font-medium md:text-black md:text-opacity-60 md:leading-[27px] md:text-left text-center max-w-[469px] xs:text-[#666] mb-8 w-auto md:mb-[27px]">
                                    {data.shortDescription}
                                  </p>
                                )}
                                {data?.bannerImage && (
                                  <div className="w-full block md:hidden md:w-[495px] h-full ml-auto mt-0">
                                    <div className="flex justify-end h-full items-center">
                                      <img
                                        src={`${process.env.NEXT_PUBLIC_AWS_URI}/${data?.bannerImage}`}
                                        width="495"
                                        height="445"
                                        className="w-full h-[auto]"
                                      />
                                    </div>
                                  </div>
                                )}

                                {data?.image && (
                                  <div className="w-full md:flex hidden mb-8">
                                    <img
                                      width="164"
                                      src={`${process.env.NEXT_PUBLIC_AWS_URI}/${data?.image}`}
                                      height="54"
                                    />
                                  </div>
                                )}
                              </div>
                              <div className="md:block xs:hidden">
                                <div className="flex items-center rounded-lg xs:w-full md:w-auto">
                                  <div className="md:flex md:flex-col block md:gap-y-3 xs:w-full">
                                    {isSessionText && data.timerText && data.showTimer && (
                                      <div className="offer-countdown ">
                                        <p className="md:mb-2 xs:block md:text-base text-sm font-medium md:leading-[19px] leading-4 ">
                                          {data.timerText}
                                        </p>
                                        <div className="flex">
                                          {data.showTimer && <Timer deadline={sessionEndTime} isHeaderTimer={true} />}
                                        </div>
                                      </div>
                                    )}

                                    <BookYourSeatButtonV2
                                      data={data}
                                      setShowBookYouSeatPopUp={setShowBookYouSeatPopUp}
                                      sectionName={`mc-click-register-${section.schemaId.code}`}
                                      setFormClickedSection={setFormClickedSection}
                                      ctaPriceText={page?.ctaPriceText || ''}
                                      programName={page.name}
                                    />
                                  </div>
                                </div>
                                {data?.bookSessionText && data?.bookSessionLinkText && (
                                  <div className="md:mt-8 md:mb-0 mb-6 mt-6 text-center md:text-left ">
                                    <p className="md:text-[18px] font-regular text-black md:leading-[22px] leading-4 text-sm">
                                      {data?.bookSessionText}
                                      <button
                                        onClick={() => {
                                          setShowSessionPopUp(!showSessionPopUp);
                                          handleDataTracker('mc-click-register-book-session', '', page.name);
                                          setFormClickedSection('mc-click-register-book-session');
                                        }}
                                        className="text-[#DB4144] font-medium underline cursor-pointer ml-1"
                                        data-bs-target="#staticBackdrop"
                                        data-bs-toggle="modal"
                                      >
                                        {data?.bookSessionLinkText}
                                      </button>
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                            {data?.bannerImage && (
                              <div className="md:col-span-6">
                                <div className="w-full hidden md:block md:w-[495px] h-full ml-auto mt-8 md:mt-0">
                                  <div className="flex justify-end h-full items-center">
                                    <img
                                      src={`${process.env.NEXT_PUBLIC_AWS_URI}/${data?.bannerImage}`}
                                      width="495"
                                      height="445"
                                      className="w-[495px] h-[445px]"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </section>
                    <section className="md:bg-[#FBF8F8] bg-[#F8FAFE] px-4 md:px-0 md:py-0 pt-8 pb-8">
                      <div className=" px-0 md:mx-auto md:max-w-[1200px] md:px-[15px]">
                        <div className="md:hidden xs:block">
                          <div className="flex items-center rounded-lg xs:w-full md:w-auto">
                            <div className="md:flex-col m:flex block md:gap-y-3 gap-y-6 xs:w-full">
                              {data.timerText && (
                                <div className="offer-countdown text-center md:text-left mb-[31px] md:mb-0">
                                  <p className="md:mb-2 mb-6 xs:block md:text-base text-sm font-regular md:font-medium md:leading-[19px] leading-4 ">
                                    {data.timerText}
                                  </p>
                                  <div className="flex justify-center md:justify-start">
                                    {data.showTimer && <Timer deadline={sessionEndTime} isHeaderTimer={true} />}
                                  </div>
                                </div>
                              )}

                              <BookYourSeatButtonV2
                                data={data}
                                setShowBookYouSeatPopUp={setShowBookYouSeatPopUp}
                                sectionName={`mc-click-register-${section.schemaId.code}`}
                                setFormClickedSection={setFormClickedSection}
                                ctaPriceText={page?.ctaPriceText || ''}
                                programName={page.name}
                              />
                            </div>
                          </div>
                          {data?.bookSessionText && data?.bookSessionLinkText && (
                            <div className="md:mt-8 md:mb-0 mt-6 text-center md:text-left ">
                              <p className="md:text-[18px] text-black font-regular md:leading-[22px] leading-4 text-sm">
                                {data?.bookSessionText}
                                <button
                                  onClick={() => {
                                    setShowSessionPopUp(!showSessionPopUp);
                                    handleDataTracker('mc-click-register-book-session', '', page.name);
                                    setFormClickedSection('mc-click-register-book-session');
                                  }}
                                  className="text-[#DB4144] font-medium underline cursor-pointer ml-1"
                                  data-bs-target="#staticBackdrop"
                                  data-bs-toggle="modal"
                                >
                                  {data?.bookSessionLinkText}
                                </button>
                              </p>
                            </div>
                          )}
                        </div>
                        {data?.tags?.length > 0 && (
                          <div className="md:justify-center flex flex-wrap border border-[#E78350] border-opacity-30  w-full md:bg-[#FBF8F8] bg-white rounded md:shadow-none shadow-[0px_3px_1px_rgb(255_123_81_/_20%)] md:border-none mt-8 md:mt-0 md:pb-12 md:mb-0 pb-0">
                            <ul className="bootcamp_list-wrap md:flex items-center flex-wrap justify-center md:gap-x-[26px] md:gap-y-6 md:px-0 px-4 md:w-auto w-full ">
                              {data.tags.map((tag: any, id: number) => {
                                return (
                                  <>
                                    <li
                                      className="bootcamp_list xs:shadow-none md:rounded rounded-none mb-0 flex items-center py-[7px] md:px-4 px-0 md:border md:border-[#E78350] md:border-opacity-30 xs:border-b xs:border-[#F4F8FF] md:shadow-[0px_3px_1px_rgb(255_123_81_/_20%)]"
                                      key={id}
                                    >
                                      <div className="flex items-center justify-center relative icon-box md:flex h-6 w-6">
                                        <span className={`bg-spriteImg ${tag.icon} flex items-center`} />
                                      </div>
                                      <div className="content-box ml-[10px]">
                                        <p className="text-sm leading-6 font-regular text-black">{tag.label}</p>
                                      </div>
                                    </li>
                                  </>
                                );
                              })}
                            </ul>
                          </div>
                        )}
                      </div>
                    </section>
                  </>
                )}
                {section.schemaId.code == 'mc-ribbon-1' && <BannerRibbon data={data} />}

                {section.schemaId.code == 'mc-program-1' && (
                  <section className="md:bg-[#FBF8F8] bg-[#F8FAFE] px-4 md:px-0 ">
                    <div className=" px-0 pt-8 pb-4 md:mx-auto md:max-w-[1200px] md:px-[15px] md:pt-20 md:pb-10 ">
                      <div className="Bootcamp-wrap bg-white  rounded-2xl border border-[#E78350] border-opacity-80 px-4 py-6 shadow-shadowCamp md:py-14 md:px-[101px]">
                        <div className="grid md:grid-cols-2 grid-cols-1 md:gap-x-[159px]">
                          <div className="bootcamp-left-wrap md:w-[407px]">
                            {data?.heading && (
                              <h2
                                className="md:text-4xl section-heading-bg text-[#181822] text-base font-bold md:mt-[3px] md:leading-[48px] max-w-[200px] md:max-w-[450px] leading-[19px] "
                                dangerouslySetInnerHTML={{ __html: data.heading }}
                              ></h2>
                            )}
                          </div>
                          {data?.keyPoints && (
                            <div className="bootcamp-right-wrap md:mt-0 mt-6 md:w-[402px]">
                              <div className="grid md:grid-cols-2 grid-cols-1 md:gap-x-[22px] md:gap-y-[38px]">
                                {data?.keyPoints.map((keyPoint) => {
                                  return (
                                    <div
                                      className="bootcamp-info relative  border-b md:border-none border-[#F4F8FF] py-4 pl-[5px] md:pl-0 md:pt-0 md:pb-0"
                                      key={keyPoint.id}
                                    >
                                      <span className="bg-[#FFE8DF] p-1 rounded-full rotate-45 md:h-[33px] md:w-[15px] w-[9px] h-[19px] absolute" />

                                      {keyPoint?.label && (
                                        <h3 className="md:text-[28px] text-[#181822] text-base font-bold mb-2 md:leading-[34px] leading-[19px] relative ">
                                          {keyPoint.label}
                                        </h3>
                                      )}
                                      {keyPoint?.tagLine && (
                                        <p className="md:text-sm text-xs leading-[25px] font-regular text-[#333] md:leading-[25px]">
                                          {keyPoint?.tagLine}
                                        </p>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                {section.schemaId.code == 'mc-program-how-does-1' && (
                  <section className="md:bg-[#FBF8F8] bg-[#F8FAFE] px-4 md:px-0">
                    <div className="pt-4 pb-8 px-0 md:mx-auto md:max-w-[1200px] md:px-[15px] md:pt-10 md:pb-20">
                      <div className="section-heading-wrap">
                        <div className="section-heading-tag -rotate-[4deg] text-center text-white">
                          {data?.title && (
                            <span className="rounded-sm bg-[#DB4144] py-1 px-2 text-base font-bold leading-[19px] md:text-[28px] md:leading-[34px] uppercase inline-block">
                              {data.title}
                            </span>
                          )}
                        </div>
                        {data?.heading && (
                          <h2 className="section-heading  text-center text-2xl font-bold uppercase leading-[29px] text-black md:mt-2 mt-3 md:text-5xl md:leading-[58px]">
                            {data?.heading}
                          </h2>
                        )}
                        {data?.description && (
                          <div className="md:text-lg text-xs text-[#111111] font-regular md:leading-[27px] leading-[18px] text-center md:max-w-[937px] w-full mx-auto md:mt-6 mt-4">
                            {data?.description}
                          </div>
                        )}
                      </div>
                      {data?.secondaryHeading && (
                        <h3
                          className="section-heading-bg-color mt-8 text-center  text-base font-bold  md:leading-[42px] leading-[21px] text-black md:mt-14 md:text-[32px]"
                          dangerouslySetInnerHTML={{ __html: data.secondaryHeading }}
                        ></h3>
                      )}
                      <div className="grid-wrap md:mt-[51px] mt-6 md:mx-[55px] md:py-0">
                        <div className="grid md:grid-cols-2 grid-cols-1 md:gap-y-8 gap-y-4 gap-x-16 px-0  ">
                          {data?.keyPoints &&
                            data?.keyPoints.map((keyPoint, id) => {
                              return (
                                <div className="check-box-center flex md:items-center items-start" key={id}>
                                  <div className="check-wrap">
                                    <label className="containers flex md:items-center items-start relative md:pl-12 pl-[26px] select-none cursor-pointer mt-0">
                                      <input
                                        type="checkbox"
                                        className="absolute h-0 w-0 opacity-0 cursor-pointer"
                                        onClick={() => {
                                          handleDataTracker('', keyPoint?.gaEventName, page.name);
                                        }}
                                      />
                                      <span className="checkmark absolute left-0  md:h-6 w-[18px] md:w-6 h-[18px] bg-white border border-black rounded-full after:absolute after:content[''] after:hidden " />
                                      {keyPoint?.label && (
                                        <div
                                          className="md:text-base text-black text-xs font-regular md:leading-6 leading-[18px]"
                                          dangerouslySetInnerHTML={{ __html: keyPoint.label }}
                                        ></div>
                                      )}
                                    </label>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                      <BookYourSeatButton
                        data={data}
                        setShowBookYouSeatPopUp={setShowBookYouSeatPopUp}
                        sectionName={`mc-click-register-${section.schemaId.code}`}
                        setFormClickedSection={setFormClickedSection}
                        customStyles="md:mt-[79px] mt-6"
                        ctaPriceText={page?.ctaPriceText || ''}
                        programName={page.name}
                      />
                    </div>
                  </section>
                )}

                {section.schemaId.code == 'mc-program-learn-1' && (
                  <section className="bg-white px-4 md:px-0">
                    <div className="py-8 px-0 md:mx-auto md:max-w-[1200px] md:px-[15px] md:py-20">
                      <div className="section-heading-wrap">
                        <div className="section-heading-tag -rotate-[4deg] text-center text-white">
                          {data?.title && (
                            <span className="rounded-sm bg-[#DB4144] py-1 px-2 text-base font-bold leading-[19px] md:text-[28px] md:leading-[34px] uppercase inline-block">
                              {data.title}
                            </span>
                          )}
                        </div>
                        {data?.heading && (
                          <h2 className="section-heading  text-center text-2xl font-bold uppercase leading-[29px] text-black md:mt-2 mt-3 md:text-5xl md:leading-[58px]">
                            {data?.heading}
                          </h2>
                        )}
                      </div>
                      {data?.keyPoints && (
                        <div className="learning-list-wrap mt-8 rounded-xl border border-[#EAEAEA] md:border-opacity-100 border-opacity-80 px-[15px] py-[14px] shadow-shadowMd md:mt-14 md:px-8 md:py-16">
                          <div className="grid md:grid-cols-2 grid-cols-1 gap-4 md:gap-6 items-start">
                            {data?.keyPoints.map((keyPoint, id) => {
                              return (
                                <>
                                  <div
                                    className="list-section w-full rounded-xl md:p-4 pl-2 pr-[14px] py-4 flex items-center"
                                    key={id}
                                  >
                                    <p
                                      className="text-xs font-semibold leading-[18px] md:text-xl md:leading-[30px]"
                                      key={id}
                                    >
                                      {id + 1}. {keyPoint.label}
                                    </p>
                                  </div>
                                </>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      <BookYourSeatButton
                        data={data}
                        setShowBookYouSeatPopUp={setShowBookYouSeatPopUp}
                        sectionName={`mc-click-register-${section.schemaId.code}`}
                        setFormClickedSection={setFormClickedSection}
                        ctaPriceText={page?.ctaPriceText || ''}
                        customStyles="md:mt-20 mt-8"
                        programName={page.name}
                      />
                    </div>
                  </section>
                )}

                {section.schemaId.code == 'mc-trainers-1' && (
                  <section className="bg-[#FBF8F8] px-4 md:px-0">
                    <div className="py-8 px-0 md:mx-auto md:max-w-[1200px] md:py-20 md:px-[15px]">
                      <div className="section-heading-wrap">
                        {data?.title && (
                          <div className="section-heading-tag -rotate-[4deg] text-center text-white">
                            <span className="rounded-sm bg-[#DB4144] py-1 px-2 text-base font-bold leading-[19px] md:text-[28px] md:leading-[34px] uppercase inline-block">
                              {data.title}
                            </span>
                          </div>
                        )}
                        {data?.heading && (
                          <h2 className="section-heading  text-center text-2xl font-bold uppercase leading-[29px] text-black mt-3 md:text-5xl md:leading-[58px]">
                            {data.heading}
                          </h2>
                        )}
                      </div>
                      {data?.trainers.length > 1 && (
                        <div className='"data-skill-list'>
                          <div className="slide-container slide-small swiper mx-auto h-[709px] md:h-auto w-full md:w-[970px]">
                            <div className="blog-content">
                              <div className="testimonial-wrappers swiper-wrapper">
                                <Swiper
                                  modules={[Pagination]}
                                  onSlideChange={(swiper) => setCurrentSlide(swiper.activeIndex + 1)}
                                  pagination={true}
                                  slidesPerView={1}
                                  breakpoints={{
                                    320: {
                                      slidesPerView: 1,
                                      spaceBetween: 12,
                                      slidesPerGroup: 1,
                                      pagination: false,
                                      navigation: {
                                        nextEl: '.trainer-next-button',
                                        prevEl: '.trainer-prev-button',
                                        disabledClass: 'disabled_swiper_button',
                                      },
                                    },
                                    768: {
                                      slidesPerView: 1,
                                      spaceBetween: 12,
                                      slidesPerGroup: 1,
                                    },
                                    1024: {
                                      slidesPerView: 1,
                                      slidesPerGroup: 1,
                                      spaceBetween: 16,
                                      pagination: {
                                        bulletClass: 'bg-gray-300 w-1.5 h-1.5',
                                        bulletActiveClass: 'bg-gray-600 !w-2 !h-2',
                                        clickable: true,
                                        renderBullet: (index, className) => {
                                          return (
                                            '<div class="cursor-pointer ' +
                                            className +
                                            ' mx-[3px] rounded-full inline-block "></div>'
                                          );
                                        },
                                      },
                                    },
                                  }}
                                  watchOverflow={true}
                                  observer
                                  observeParents
                                  onBeforeInit={(swiper) => {
                                    swiperRef.current = swiper;
                                  }}
                                  spaceBetween={16}
                                >
                                  {data.trainers.map((trainer, index) => {
                                    return (
                                      <SwiperSlide key={index}>
                                        <div className="swiper-slide">
                                          {trainer?.image && (
                                            <div className="user-image mt-[39px] flex justify-center md:mt-[42px]">
                                              <img
                                                className="mb-[-48px] h-20 w-20 md:h-24 md:w-24"
                                                src={`${process.env.NEXT_PUBLIC_AWS_URI}/${trainer.image}`}
                                                alt={trainer?.name}
                                              />
                                            </div>
                                          )}
                                          <div className="testimonial_wrap mx-auto rounded-xl border border-[#EEEEEE] bg-white px-4 pt-16 pb-[42px] md:px-10 md:py-[72px] md:h-[575px] h-[582px]">
                                            <div className="testimonal-head">
                                              {trainer?.name && (
                                                <div className="user-name mb-2 text-center text-base font-bold leading-[19px] text-black md:text-2xl md:leading-[29px]">
                                                  {trainer.name}
                                                </div>
                                              )}

                                              {trainer?.designation && (
                                                <div className="flex md:gap-x-2 gap-x-1 justify-center items-center">
                                                  <div className="institute mb-2 text-center text-[#333333] text-sm font-regular leading-[21px] md:text-lg md:leading-[21px]">
                                                    {trainer.designation}
                                                  </div>
                                                  {trainer?.linkedinUrl && (
                                                    <a
                                                      href={trainer?.linkedinUrl}
                                                      target="_blank"
                                                      rel="noopener noreferrer nofollow"
                                                    >
                                                      <div>
                                                        <img
                                                          src="https://d2o2utebsixu4k.cloudfront.net/assets/images/icons/form-linkedin.png"
                                                          width="18"
                                                          height="18"
                                                        />
                                                      </div>
                                                    </a>
                                                  )}
                                                </div>
                                              )}
                                              {trainer?.company && (
                                                <div className="institute text-center text-sm font-semibold leading-4 md:text-lg md:leading-[21px]">
                                                  {trainer.company}
                                                </div>
                                              )}
                                            </div>

                                            <div className="mt-8 md:border-t md:mt-10 md:border-t-[#EEEEEE] border-t-0">
                                              <div className="testimonial-body mx-auto mt-10 w-full md:w-[680px] md:p-0 px-[22px]">
                                                {trainer?.keyPoints && (
                                                  <div className="grid md:grid-cols-2 grid-cols-1 md:gap-4 gap-3 items-start">
                                                    {trainer?.keyPoints.map((keyPoint, id) => {
                                                      return (
                                                        <div
                                                          className="testimonial-list flex items-center testIcon-sm relative rounded bg-black p-3 text-sm font-medium leading-[17px] text-white before:absolute before:top-2 before:h-6 before:w-6 md:pt-[14px] md:pb-[18px] md:px-8 md:text-xl md:leading-[30px] md:before:top-4"
                                                          key={id}
                                                        >
                                                          <p className="pl-8">{keyPoint.label}</p>
                                                        </div>
                                                      );
                                                    })}
                                                  </div>
                                                )}
                                              </div>
                                              {trainer?.description && (
                                                <p
                                                  className="mt-6 text-center text-sm font-regular leading-[21px] md:mt-8 md:text-xl md:h-[90px] overflow-hidden md:leading-[30px] text-limit"
                                                  dangerouslySetInnerHTML={{ __html: trainer?.description }}
                                                ></p>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </SwiperSlide>
                                    );
                                  })}
                                </Swiper>
                              </div>
                              <div className="swiper-pagination blog-pagination hidden px-6  md:flex items-center" />
                            </div>
                            {data.trainers?.length > 1 && (
                              <div
                                onClick={() => swiperRef.current?.slideNext()}
                                className={`${
                                  currentSlide == data?.trainers?.length ? 'swiper-button-disabled' : ''
                                } swiper-button-next blog-next bg-spriteImg  `}
                              />
                            )}
                            {data.trainers?.length > 1 && (
                              <div
                                onClick={() => swiperRef.current?.slidePrev()}
                                className={` ${
                                  currentSlide == 1 ? 'swiper-button-disabled' : ''
                                } swiper-button-prev blog-prev bg-spriteImg`}
                              />
                            )}
                          </div>
                        </div>
                      )}
                      {data?.trainers?.length == 1 && (
                        <>
                          {data?.trainers && (
                            <div className='"data-skill-list'>
                              <div className="slide-container slide-small swiper mx-auto h-[709px] md:h-auto w-full md:w-[970px]">
                                <div className="blog-content">
                                  <div className="testimonial-wrappers swiper-wrapper">
                                    {data.trainers.map((trainer, index) => {
                                      return (
                                        <div className="swiper-slide" key={index}>
                                          {trainer?.image && (
                                            <div className="user-image mt-[39px] flex justify-center md:mt-[42px]">
                                              <img
                                                className="mb-[-48px] h-20 w-20 md:h-24 md:w-24"
                                                src={`${process.env.NEXT_PUBLIC_AWS_URI}/${trainer.image}`}
                                                alt={trainer?.name}
                                              />
                                            </div>
                                          )}
                                          <div className="testimonial_wrap mx-auto rounded-xl border border-[#EEEEEE] bg-white px-4 pt-16 pb-[42px] md:px-10 md:py-[72px] md:h-[575px] h-[582px]">
                                            <div className="testimonal-head">
                                              {trainer?.name && (
                                                <div className="user-name mb-2 text-center text-base font-bold leading-[19px] text-black md:text-2xl md:leading-[29px]">
                                                  {trainer.name}
                                                </div>
                                              )}

                                              {trainer?.designation && (
                                                <div className="flex md:gap-x-2 gap-x-1 justify-center items-center">
                                                  <div className="institute mb-2 text-center text-[#333333] text-sm font-regular leading-[21px] md:text-lg md:leading-[21px]">
                                                    {trainer.designation}
                                                  </div>
                                                  {trainer?.linkedinUrl && (
                                                    <a
                                                      href={trainer?.linkedinUrl}
                                                      target="_blank"
                                                      rel="noopener noreferrer nofollow"
                                                    >
                                                      <div>
                                                        <img
                                                          src="https://d2o2utebsixu4k.cloudfront.net/assets/images/icons/form-linkedin.png"
                                                          width="18"
                                                          height="18"
                                                        />
                                                      </div>
                                                    </a>
                                                  )}
                                                </div>
                                              )}
                                              {trainer?.company && (
                                                <div className="institute text-center text-sm font-semibold leading-4 md:text-lg md:leading-[21px]">
                                                  {trainer.company}
                                                </div>
                                              )}
                                            </div>

                                            <div className="mt-8 md:border-t md:mt-10 md:border-t-[#EEEEEE] border-t-0">
                                              <div className="testimonial-body mx-auto mt-10 w-full md:w-[680px] md:p-0 px-[22px]">
                                                {trainer?.keyPoints && (
                                                  <div className="grid md:grid-cols-2 grid-cols-1 md:gap-4 gap-3 items-start">
                                                    {trainer?.keyPoints.map((keyPoint, id) => {
                                                      return (
                                                        <div
                                                          className="testimonial-list flex items-center testIcon-sm relative rounded bg-black p-3 text-sm font-medium leading-[17px] text-white before:absolute before:top-2 before:h-6 before:w-6 md:pt-[14px] md:pb-[18px] md:px-8 md:text-xl md:leading-[30px] md:before:top-4"
                                                          key={id}
                                                        >
                                                          <p className="pl-8">{keyPoint.label}</p>
                                                        </div>
                                                      );
                                                    })}
                                                  </div>
                                                )}
                                              </div>
                                              {trainer?.description && (
                                                <p
                                                  className="mt-6 text-center text-sm font-regular leading-[21px] md:mt-8 md:text-xl md:h-[90px] overflow-hidden md:leading-[30px] text-limit"
                                                  dangerouslySetInnerHTML={{ __html: trainer?.description }}
                                                ></p>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                  <div className="swiper-pagination blog-pagination hidden px-6  md:flex items-center" />
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </section>
                )}

                {section.schemaId.code == 'mc-program-for-1' && (
                  <section className="bg-white px-4 md:px-0">
                    <div className="py-8 px-0 md:mx-auto md:max-w-[1200px] md:py-20 md:px-[15px]">
                      <div className="section-heading-wrap">
                        <div className="section-heading-tag -rotate-[4deg] text-center text-white">
                          {data?.title && (
                            <span className="rounded-sm bg-[#DB4144] py-1 px-2 text-base font-bold leading-[19px] md:text-[28px] md:leading-[34px] uppercase inline-block">
                              {data.title}
                            </span>
                          )}
                        </div>
                        {data?.heading && (
                          <h2 className="section-heading  text-center text-2xl font-bold uppercase leading-[29px] text-black md:mt-2 mt-3 md:text-5xl md:leading-[58px]">
                            {data?.heading}
                          </h2>
                        )}
                      </div>
                      <div className="program-list-wrap md:mt-14 mt-8 flex justify-center">
                        <div className="grid w-[818px] grid-cols-none md:gap-y-8 gap-y-[14px] md:grid-flow-row md:grid-cols-4  md:gap-x-10 grid-template-columns:auto">
                          {data?.keyPoints && (
                            <>
                              {data.keyPoints.map((keyPoint, id) => {
                                return (
                                  <div
                                    className="program-list text-black relative col-span-2 md:text-[22px] text-sm font-regular md:leading-[33px] leading-[21px] before:absolute md:before:top-[7px] before:top-[2px]  md:before:h-5 md:before:w-5 before:w-4 before:h-4 before:bg-spriteImg"
                                    key={id}
                                  >
                                    <div className="md:pl-8 pl-[26px]">{keyPoint.label}</div>
                                  </div>
                                );
                              })}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </section>
                )}
                {section.schemaId.code == 'mc-reviews-1' && (
                  <section className="md:bg-[#FBF8F8] bg-[#F8FAFE] px-4 md:px-0">
                    <div className="py-8 px-0 md:mx-auto md:max-w-[1200px] md:py-20 md:px-4">
                      <div className="section-heading-wrap">
                        <div className="section-heading-tag -rotate-[4deg] text-center text-white">
                          {data?.title && (
                            <span className="rounded-sm bg-[#DB4144] py-1 px-2 text-base font-bold leading-[19px] md:text-[28px] md:leading-[34px] uppercase inline-block">
                              {data.title}
                            </span>
                          )}
                        </div>
                        {data?.heading && (
                          <h2 className="section-heading text-center text-2xl font-bold uppercase leading-[29px] text-black mt-3 md:text-5xl md:leading-[58px]">
                            {data.heading}
                          </h2>
                        )}
                      </div>
                      <div className="block md:hidden mt-[39px] md:mt-0">
                        <Reviews reviews={data?.reviews} />
                      </div>
                      <div className="hidden md:block">
                        {data?.reviews && (
                          <div className="data-skill-list pt-4 md:pt-14">
                            <div className="slide-container swiper mx-auto w-full">
                              <div className="slider-content">
                                <div className="card-wrappers grid-cols-3 swiper-wrapper gap-[30px] ">
                                  {data?.reviews.map((review, id) => {
                                    return (
                                      <div className="swiper-slide rounded bg-white" key={id}>
                                        <div className="course_box md:p-6 p-4">
                                          <div className="user-header-wrap mb-6 flex justify-between border-b border-[#EEEEEE] pb-6">
                                            <div className="card-header flex items-center">
                                              <div className="uesr-pic w-[38px] h-[38px] md:h-14 md:w-14 rounded-full">
                                                <img
                                                  src={`${process.env.NEXT_PUBLIC_AWS_URI}/${review.image}`}
                                                  width="100"
                                                  height="100"
                                                  className="rounded-full"
                                                />
                                              </div>
                                              <div className="user-info ml-3">
                                                {review?.name && (
                                                  <h3 className="md:text-lg text-base text-[#111111] font-bold md:leading-[22px] max-w-[240px] overflow-hidden h-[22px] leading-5">
                                                    {review.name}
                                                  </h3>
                                                )}
                                                {review?.designation && (
                                                  <p className="mt-1 md:text-sm text-[#666666] text-xs font-regular md:leading-[17px] max-w-[240px] overflow-hidden h-[17px] leading-[14px]">
                                                    ({review.designation})
                                                  </p>
                                                )}
                                              </div>
                                            </div>
                                            <div className="qutation-icon md:h-[15px] md:w-[18px] w-[11px] h-[10px] bg-spriteImg" />
                                          </div>
                                          <div className="card-body">
                                            <div className="card-sub-header mb-6 flex justify-between">
                                              <div className="flex gap-x-[7px]">
                                                {review?.rating > 0 &&
                                                  [...Array(review.rating)].map((e, i) => {
                                                    return (
                                                      <div
                                                        className="rate-icon md:h-[17px] md:w-[18px] w-4 h-[14px] bg-spriteImg"
                                                        key={i}
                                                      />
                                                    );
                                                  })}
                                              </div>
                                              {review?.date && (
                                                <div className="date-year text-sm font-semibold leading-5 text-[#666666]">
                                                  {`${toMonthName(new Date(review.date).getMonth() + 1)}, ${new Date(
                                                    review.date
                                                  ).getFullYear()}`}
                                                </div>
                                              )}
                                            </div>
                                            {review?.review && (
                                              <div
                                                className="user-Textlimit text-sm font-regular leading-5 md:text-xl md:leading-[30px]"
                                                dangerouslySetInnerHTML={{ __html: review.review }}
                                              ></div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                                <div className="swiper-pagination acc-pagination text-swiperFrac text-[13px] font-bold leading-[18px] md:hidden" />
                              </div>
                              <div className="swiper-button-next acc-next hidden bg-spriteImg" />
                              <div className="swiper-button-prev acc-prev hidden bg-spriteImg" />
                            </div>
                          </div>
                        )}
                      </div>

                      <BookYourSeatButton
                        data={data}
                        setShowBookYouSeatPopUp={setShowBookYouSeatPopUp}
                        sectionName={`mc-click-register-${section.schemaId.code}`}
                        setFormClickedSection={setFormClickedSection}
                        ctaPriceText={page?.ctaPriceText || ''}
                        customStyles="md:mt-20"
                        programName={page.name}
                      />
                    </div>
                  </section>
                )}
                {section.schemaId.code == 'mc-companies-1' && (
                  <section className="bg-white px-4 md:px-0">
                    <div className="py-8 px-0 md:mx-auto md:max-w-[1200px] md:py-20 md:px-[15px]">
                      <div className="section-heading-wrap">
                        <div className="section-heading-tag -rotate-[4deg] text-center text-white">
                          {data?.title && (
                            <span className="rounded-sm bg-[#DB4144] py-1 px-2 text-base font-bold leading-[19px] md:text-[28px] md:leading-[34px] uppercase inline-block">
                              {data.title}
                            </span>
                          )}
                        </div>
                        {data?.heading && (
                          <h2 className="section-heading  text-center text-2xl font-bold uppercase leading-[29px] text-black mt-3 md:text-5xl md:leading-[58px]">
                            {data.heading}
                          </h2>
                        )}
                      </div>
                      {data?.companies && (
                        <div className="company-img-wrap flex w-full justify-center rounded-xl md:py-[53px] pt-8 md:mt-14 md:border md:border-[#DDDDDD]">
                          <div className="flex flex-wrap justify-center md:gap-y-8 gap-y-6">
                            {data?.companies.map((company, id) => {
                              return (
                                <div
                                  className="md:h-14 md:w-[194px] h-10 w-[130px] flex justify-center items-center"
                                  key={id}
                                >
                                  <div className={`${company.icon} bg-spriteImg flex items-center`} />
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  </section>
                )}
                {section.schemaId.code == 'mc-certificates-1' && (
                  <section className="md:bg-[#FBF8F8] bg-[#F8FAFE] px-4 md:px-0">
                    <div className="py-8 px-0 md:mx-auto md:max-w-[1200px] md:py-20 md:px-[15px]">
                      <div className="block gap-x-[156px] md:flex">
                        <div className="w-full md:w-[530px]">
                          <div className="section-heading-wrap">
                            <div className="mobile-center flex justify-center md:justify-start">
                              <div className="section-heading-tag -rotate-[4deg] text-center text-white">
                                {data?.title && (
                                  <span className="rounded-sm bg-[#DB4144] py-1 px-2 text-base font-bold leading-[19px] md:text-[28px] md:leading-[34px] uppercase inline-block">
                                    {data.title}
                                  </span>
                                )}
                              </div>
                            </div>

                            {data?.heading && (
                              <h2 className="section-heading text-center md:text-left text-2xl font-bold uppercase leading-[29px] text-black mt-3 md:text-5xl md:leading-[58px] md:mb-3 mb-4">
                                {data.heading}
                              </h2>
                            )}
                            {data?.description && (
                              <div className="md:text-lg md:leading-[27px] mb-6 md:max-w-[392px] md:mb-10 text-center text-xs leading-[18px] md:text-[#333333] text-[#111111] font-regular md:text-left">
                                {data.description}
                              </div>
                            )}
                          </div>
                          {data?.keyPoints && (
                            <div className="certificate-feauters ">
                              {data?.keyPoints.map((keyPoint, id) => {
                                return (
                                  <div
                                    className="certificate-list relative mb-6 last:mb-0 md:pl-[52px] pl-[44px]  font-regular leading-[33px] before:absolute before:top-0 before:left-0 before:h-8 before:w-8 md:before:h-10 md:before:w-10 before:bg-spriteImg"
                                    key={id}
                                  >
                                    <p className="text-sm md:pt-[3px] pt-[5px] text-black font-semibold leading-[21px] md:text-base md:leading-6">
                                      {keyPoint.heading}
                                    </p>
                                    <p className=" workshop-limit mt-4 text-xs font-regular leading-[18px] md:mt-2  md:h-9 overflow-hidden md:w-[314px] w-full text-[#666666]">
                                      {keyPoint.description}
                                    </p>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                        <div className="w-full md:w-[484px] mt-8 md:mt-0">
                          <div className="certificate-wrap flex justify-center h-full items-center">
                            <img src={`${process.env.NEXT_PUBLIC_AWS_URI}/${data.image}`} width="484" height="340" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}
                {section.schemaId.code == 'mc-workshop-flow-1' && (
                  <section className="bg-white px-4  md:px-0  ">
                    <div className="py-8 px-0 md:mx-auto md:max-w-[1200px] md:py-20 md:px-[15px]">
                      <div className="section-heading-wrap">
                        <div className="section-heading-tag -rotate-[4deg] text-center text-white">
                          {data?.title && (
                            <span className="rounded-sm bg-[#DB4144] py-1 px-2 text-base font-bold leading-[19px] md:text-[28px] md:leading-[34px] uppercase inline-block">
                              {data.title}
                            </span>
                          )}
                        </div>
                        {data?.heading && (
                          <h2 className="section-heading  text-center text-2xl font-bold uppercase leading-[29px] text-black md:mt-2 mt-3 md:text-5xl md:leading-[58px]">
                            {data?.heading}
                          </h2>
                        )}
                        {data?.description && (
                          <div className="flex justify-center">
                            <p className="md:mt-6 mt-4 text-center md:text-lg text-xs font-regular md:leading-[27px] leading-[18px] max-w-[556px] ">
                              {data?.description}
                            </p>
                          </div>
                        )}
                      </div>
                      <div className="workshop-wrap md:w-[794px] w-full mx-auto md:mt-14 mt-6 relative">
                        <div className="absolute mt-4 pl-[41px] md:block hidden left-[35%]">
                          <img src={`${process.env.NEXT_PUBLIC_AWS_URI}/${data.image}`} width="197" height="599" />
                        </div>

                        <div className="workshop-sec xs:block md:relative">
                          <div className="work-box md:border-[#C6C6C6]  md:border xs:border-0 rounded-xl p-5 md:w-[300px] w-full hover:border-[#E78350] hover:rounded-2xl transition-all duration-300 hover:border-opacity-80 cursor-pointer">
                            <div className={`${data?.steps[0]?.icon} bg-spriteImg w-10 h-10`} />
                            <h4 className="ws-odd mt-4 md:text-xl text-base font-bold md:leading-7 leading-[19px] h-auto">
                              {data?.steps[0]?.heading}
                            </h4>
                            <p className="ws-all md:mt-4 mt-2 md:text-base text-xs font-regular md:leading-7 leading-[18px]">
                              {data?.steps[0]?.description}
                            </p>
                          </div>
                          <div className="work-box md:border-[#C6C6C6]  md:border xs:border-0 rounded-xl p-5 md:w-[258px] w-full md:absolute right-0 top-[72px] hover:border-[#E78350] hover:rounded-2xl transition-all duration-300 hover:border-opacity-80 cursor-pointer">
                            <div className={`${data?.steps[1]?.icon} bg-spriteImg w-10 h-10`} />
                            <h4 className="ws-even mt-4 md:text-xl text-base font-bold md:leading-7 leading-5  h-auto">
                              {data?.steps[1]?.heading}
                            </h4>
                            <p className="ws-all md:mt-4 mt-2 md:text-base text-xs font-regular md:leading-7 leading-[18px]">
                              {data?.steps[1]?.description}
                            </p>
                          </div>
                          <div className="work-box md:border-[#C6C6C6]  md:border xs:border-0 rounded-xl p-5 md:w-[300px] w-full md:mt-[98px] hover:border-[#E78350] hover:rounded-2xl transition-all duration-300 hover:border-opacity-80 cursor-pointer">
                            <div className={`${data?.steps[2]?.icon} bg-spriteImg w-10 h-10`} />
                            <h4 className="ws-odd mt-4 md:text-xl text-base font-bold md:leading-7 leading-5  h-auto">
                              {data?.steps[2]?.heading}
                            </h4>
                            <p className="ws-all md:mt-4 mt-2 md:text-base text-xs font-regular md:leading-7 leading-[18px]">
                              {data?.steps[2]?.description}
                            </p>
                          </div>
                          <div className="work-box md:border-[#C6C6C6]  md:border xs:border-0 rounded-xl p-5 md:w-[258px] w-full md:absolute right-0 top-[398px] hover:border-[#E78350] hover:rounded-2xl transition-all duration-300 hover:border-opacity-80 cursor-pointer">
                            <div className={`${data?.steps[3]?.icon} bg-spriteImg w-10 h-10`} />
                            <h4 className="ws-even mt-4 md:text-xl text-base font-bold md:leading-7 leading-5  h-auto">
                              {data?.steps[3]?.heading}
                            </h4>
                            <p className="ws-all md:mt-4 mt-2 md:text-base text-xs font-regular md:leading-7 leading-[18px]">
                              {data?.steps[3]?.description}
                            </p>
                          </div>
                          <div className="work-box md:border-[#C6C6C6]  md:border xs:border-0 rounded-xl p-5 md:w-[300px] w-full md:mt-[70px] hover:border-[#E78350] hover:rounded-2xl transition-all duration-300 hover:border-opacity-80 cursor-pointer">
                            <div className={`${data?.steps[4]?.icon} bg-spriteImg w-10 h-10`} />
                            <h4 className="ws-odd mt-4 md:text-xl text-base font-bold md:leading-7 leading-5  h-auto">
                              {data?.steps[4]?.heading}
                            </h4>
                            <p className="ws-all md:mt-4 mt-2 md:text-base text-xs font-regular md:leading-7 leading-[18px]">
                              {data?.steps[4]?.description}
                            </p>
                          </div>
                        </div>
                      </div>
                      <BookYourSeatButton
                        data={data}
                        setShowBookYouSeatPopUp={setShowBookYouSeatPopUp}
                        sectionName={`mc-click-register-${section.schemaId.code}`}
                        setFormClickedSection={setFormClickedSection}
                        ctaPriceText={page?.ctaPriceText || ''}
                        customStyles="md:mt-20 mt-8"
                        programName={page.name}
                      />
                    </div>
                  </section>
                )}
                {section.schemaId.code == 'mc-bonus-1' && (
                  <section className="bg-white px-4 md:bg-[#FBF8F8] md:px-0">
                    <div className="py-8 px-0 md:mx-auto md:max-w-[1200px] md:py-20 md:px-[15px]">
                      <div className="section-heading-wrap">
                        <div className="section-heading-tag -rotate-[4deg] text-center text-white">
                          {data?.title && (
                            <span
                              className="rounded-sm bg-[#DB4144] py-1 px-2 xs:text-base uppercase font-bold leading-19 md:text-[28px] md:leading-34"
                              dangerouslySetInnerHTML={{ __html: data.title }}
                            ></span>
                          )}
                        </div>
                        {data?.heading && (
                          <h2
                            className="section-heading-bg-color  text-center text-2xl font-bold uppercase leading-[29px] text-black mt-3 md:text-5xl md:leading-[58px]"
                            dangerouslySetInnerHTML={{ __html: data?.heading }}
                          ></h2>
                        )}
                      </div>
                      {data?.keyPoints && (
                        <div className="md:mt-14 mt-8 grid grid-cols-1 gap-[30px] md:grid-cols-2">
                          {data?.keyPoints.map((keyPoint, id) => {
                            return (
                              <div
                                className="rounded bg-[#F8FAFE] md:px-8 px-4 md:pt-8 pt-4 pb-6 md:h-[304px] md:bg-white relative "
                                key={id}
                              >
                                <div
                                  className={`${keyPoint.icon} md:mb-[6px] mb-4 block h-10 w-10 bg-spriteImg md:h-14 md:w-14 align-top`}
                                ></div>

                                <h3 className="text-base font-bold leading-6 md:text-lg md:leading-7 md:max-h-14 overflow-hidden">
                                  {keyPoint?.heading}
                                </h3>
                                <div className="md:my-4 mt-2 mb-4 text-xs font-regular leading-[18px] md:text-base md:leading-7 md:h-14 overflow-hidden ">
                                  {keyPoint?.description}
                                </div>
                                <span className="rounded-[72px] bg-[#F9F0EB] px-4 md:py-[10px] py-[5px] md:text-sm text-xs md:absolute md:bottom-6 leading-[17px] md:leading-[22px] font-bold text-black bots inline-block">
                                  {keyPoint.priceText}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </section>
                )}
                {section.schemaId.code == 'mc-participate-1' && (
                  <section className="bg-white px-4 md:px-0">
                    <div className="flex justify-center py-8 px-0 md:mx-auto md:max-w-[1200px] md:py-20 md:px-[15px]">
                      {data?.mobileImage && data?.desktopImage && (
                        <>
                          <div className="md:hidden w-full">
                            {/* added static image */}
                            <span className="next-image-styles">
                              <img
                                src={`${process.env.NEXT_PUBLIC_AWS_URI}/${data.mobileImage}`}
                                alt={'Participate Image'}
                                className="!w-full !min-w-[auto] !h-auto"
                                width="100%"
                                height="100%"
                              />
                            </span>
                          </div>
                          <div className="hidden md:block   max-w-[972px] w-full next-image-styles">
                            {/*  */}
                            <img
                              src={`${process.env.NEXT_PUBLIC_AWS_URI}/${data.desktopImage}`}
                              alt={'Participate Image'}
                              className="!w-full !h-full"
                              width="100%"
                              height="100%"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </section>
                )}
                {section.schemaId.code == 'mc-faqs-1' && (
                  <>
                    <section className="accordian md:bg-[#FBF8F8] bg-[#F8FAFE]">
                      <div className="px-3 md:py-20 py-8 md:mx-auto md:max-w-[1200px] md:px-[15px]">
                        {data?.faq_heading && (
                          <h2 className="font-bold md:text-2xl text-base xs:leading-6 text-center md:mb-10 mb-6">
                            {data?.faq_heading}
                          </h2>
                        )}
                        {data?.faq_blocks && (
                          <div className="accordian-wrap md:w-[770px] w-full mx-auto">
                            <div className="accordion accordion-flush" id="accordionFlushExample">
                              <FaqBlock FaqBlocks={data?.faq_blocks} />
                            </div>
                          </div>
                        )}
                      </div>
                    </section>
                    {data?.ctaText && (
                      <section className="last-button bg-white">
                        <div className="px-3 md:py-24 py-8 md:mx-auto md:max-w-[1200px] md:px-[15px]">
                          <BookYourSeatButton
                            data={data}
                            setShowBookYouSeatPopUp={setShowBookYouSeatPopUp}
                            sectionName={`mc-click-register-${section.schemaId.code}`}
                            setFormClickedSection={setFormClickedSection}
                            ctaPriceText={page?.ctaPriceText || ''}
                            programName={page.name}
                          />
                        </div>
                      </section>
                    )}
                  </>
                )}
              </>
            );
          })}

          {page?.tenant?.slug == 'upgrad' && <UpGradFooter />}

          {page?.tenant?.slug == 'knowledgehut' && (
            <SessionPopup
              isOpen={showSessionPopUp}
              setOpen={setShowSessionPopUp}
              title={'Speak to our academic counselor'}
              description="Get started by booking a 1-on-1 consultation with our experts"
              sectionName="mc-submit-book-session"
              program={page?.name}
            />
          )}

          {page?.tenant?.slug == 'knowledgehut' &&
            page.pageType == 'master-class' &&
            bannerInfo &&
            bannerInfo.schemaId.code == 'mc-banner-1' && (
              <BookYourSeatForm
                title={'Book Your Seat'}
                description={
                  'Congratulations on taking your first steps to leveling up your career! You’re just one step away from getting access to our transformation FREE Masterclass.'
                }
                isOpen={showBookYouSeatPopUp}
                setOpen={setShowBookYouSeatPopUp}
                isOTPVerified={page?.isEnableOTPVerification || false}
                sectionName={formClickedSection}
                webinarDate={sessionTime}
                program={page?.name}
                zoomLink={page?.zoomLink}
              />
            )}

          {page?.tenant?.slug == 'knowledgehut' &&
            page.pageType == 'master-class' &&
            bannerInfo &&
            bannerInfo.schemaId.code == 'mc-banner-2' && (
              <BookYourSeatPopUpV2
                title={'Book Your Seat'}
                description={
                  'Congratulations on taking your first steps to leveling up your career! You’re just one step away from getting access to our transformation FREE Masterclass.'
                }
                isOpen={showBookYouSeatPopUp}
                setOpen={setShowBookYouSeatPopUp}
                isOTPVerified={page?.isEnableOTPVerification || false}
                sectionName={formClickedSection}
                webinarDate={sessionTime}
                program={page?.name}
                zoomLink={page?.zoomLink}
              />
            )}

          {page?.tenant?.slug == 'upgrad' &&
            page.pageType == 'master-class' &&
            bannerInfo &&
            bannerInfo.schemaId.code == 'mc-banner-1' && (
              <UGBookYourSeatForm
                title={'Book Your Seat'}
                description={
                  'Congratulations on taking your first steps to leveling up your career! You’re just one step away from getting access to our transformation FREE Masterclass.'
                }
                isOpen={showBookYouSeatPopUp}
                setOpen={setShowBookYouSeatPopUp}
                isOTPVerified={page?.isEnableOTPVerification || false}
                sectionName={formClickedSection}
                webinarDate={sessionTime}
                webinarEndDate={webinarEndDate}
                webinarId={page?.webinarId}
                zoomLink={page?.zoomLink}
                instructor={page?.zoomTrainerName}
                classType={page?.pageType}
                program={page?.name}
              />
            )}

          {page &&
            page?.tenant?.slug == 'upgrad' &&
            page.pageType == 'master-class' &&
            bannerInfo &&
            bannerInfo.schemaId.code == 'mc-banner-2' && (
              <UgBookYourSeatPopUpV2
                title={'Book Your Seat'}
                description={
                  'Congratulations on taking your first steps to leveling up your career! You’re just one step away from getting access to our transformation FREE Masterclass.'
                }
                isOpen={showBookYouSeatPopUp}
                setOpen={setShowBookYouSeatPopUp}
                isOTPVerified={page?.isEnableOTPVerification || false}
                sectionName={formClickedSection}
                webinarDate={sessionTime}
                webinarEndDate={webinarEndDate}
                webinarId={page?.webinarId}
                zoomLink={page?.zoomLink}
                instructor={page?.zoomTrainerName}
                classType={page?.pageType}
                program={page?.name}
              />
            )}

          {page?.tenant?.slug == 'upgrad' && (
            <UpgradSessionPopup
              isOpen={showSessionPopUp}
              setOpen={setShowSessionPopUp}
              title={'Speak to our academic counselor'}
              description="Get started by booking a 1-on-1 consultation with our experts"
              sectionName="mc-submit-book-session"
              isOTPVerified={page?.isEnableOTPVerification || false}
              webinarDate={sessionTime}
              webinarEndDate={webinarEndDate}
              webinarId={page?.webinarId}
              zoomLink={page?.zoomLink}
              instructor={page?.zoomTrainerName}
              classType={page?.pageType}
              program={page?.name}
            />
          )}
        </div>
      </CommonContext.Provider>
    </MasterClassContainer>
  );
};
export default MasterClassLayout;
